import { Effect, Layer, Option, Stream, Tuple } from 'effect';
import { RealisationsService } from './service';
import { AxiosHttpService, HttpService } from '../../services/http';
import { GluonConfig } from '../../services/gluonConfig';
import { GetAllRealisations, makeGetAllRealisationsResolver } from './gluon/getAllRealisations';
import { TokenProviderService } from '../../services/tokenProvider';
const makeGluonRealisationsService = Effect.gen(function* () {
    const http = yield* HttpService;
    const { gluonUrl } = yield* GluonConfig;
    const tokenProvider = yield* TokenProviderService;
    const getAllRealisationsResolver = makeGetAllRealisationsResolver(http);
    const streamAll = (tenant, query = {}) => Stream.paginateEffect(undefined, cursor => {
        return Effect.gen(function* () {
            const token = yield* tokenProvider.getToken();
            const request = GetAllRealisations({
                baseUrl: gluonUrl,
                tenant,
                limit: query.limit ?? 1000,
                cursor,
                bearerToken: token,
                ...query,
            });
            const result = yield* Effect.request(request, getAllRealisationsResolver);
            return Tuple.make(result.realisations, Option.fromNullable(result.cursor));
        });
    });
    return { streamAll };
});
export const BaseGluonRealisationsServiceLayer = Layer.effect(RealisationsService, makeGluonRealisationsService);
export const DefaultRealisationServiceLayer = BaseGluonRealisationsServiceLayer.pipe(Layer.provide(AxiosHttpService));
